import { createSlice, PayloadAction } from "@reduxjs/toolkit"

export interface IAvailableScheduleCandidates {
  id: number | null
  name: string | null
  status: string | null
  eliminationStage: string | null
}

export interface IAvailableScheduleCandidatesArray {
  candidates: IAvailableScheduleCandidates[] | []
}

const IAvailableScheduleCandidatesState: IAvailableScheduleCandidatesArray = {
  candidates: [],
}

const AvalaibleScheduleSlice = createSlice({
  name: "AvalaibleSchedule",
  initialState: IAvailableScheduleCandidatesState,
  reducers: {
    setAvailableScheduleCandidates: (
      state,
      action: PayloadAction<IAvailableScheduleCandidatesArray>,
    ) => {
      state.candidates = action.payload.candidates
    },
  },
})

export const avalaibleScheduleReducer = AvalaibleScheduleSlice.reducer

export const { setAvailableScheduleCandidates } = AvalaibleScheduleSlice.actions
